var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVine9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2560 1440",
    preserveAspectRatio: "xMidYMid slice",
    width: "100%",
    height: "100%",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "vineGradient",
    x1: 0,
    y1: 0,
    x2: 50,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#264d3b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#5fae8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#b2f0e3"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "layer"
  }, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("path", {
    d: "m-138.48,168.67c0,0 358.33,252.98 645.24,323.81c286.9,70.83 480.95,60.12 611.1,-6.76c130.14,-66.88 287.71,-354.55 54.38,-477.17c-233.33,-122.62 -417.86,179.17 -346.43,372.02c71.43,192.86 298.81,251.79 507.14,264.29c208.33,12.5 454.17,-12.5 749.19,-207.95c295.02,-195.45 319.86,-471.81 312.12,-617.64c-7.74,-145.83 10.12,-83.93 -222.83,-264.5c-232.95,-180.57 -543.24,-221.81 -714.29,-19.05c-171.05,202.76 47.24,394.86 142.48,454.38c95.24,59.52 623.81,197.62 621.81,671.81c-2,474.19 -371.81,542.48 -459.9,571.05c-88.1,28.57 -498.81,152.38 -980.61,-57.99c-240.9,-105.18 -440.19,-218.91 -699.18,-116.74c-258.99,102.17 -370.52,550.61 -421.62,516.18c-102.19,-68.86 24.73,-545.21 73.17,-616.12c48.44,-70.9 80.05,-689.29 97.32,-727.45c17.27,-38.16 30.91,-62.17 30.91,-62.17z",
    fill: "#000000",
    fillOpacity: 0,
    id: "vinePath",
    stroke: "#000000",
    strokeWidth: 50
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVine9);
export default __webpack_public_path__ + "static/media/vine9.a22ebe453abc2c9cfdf1d220c6993cd4.svg";
export { ForwardRef as ReactComponent };